module.exports = __webpack_public_path__ + "img/Convertibles.e1aaa607.svg";